import React from 'react';
import { CheckboxInput } from '@awarego-ui/components';
import HtmlField from '../../../components/inputs/htmlField';

const CustomizableHtmlField = ({
    label,
    fieldName,
    enabledFieldName,
    form,
    initialValue,
    onEnabledChange,
}) => {
    const field = form.$(fieldName);
    const enabledField = form.$(enabledFieldName);
    const mrkdownField = form.$(`mrkdwn_${fieldName}`);
    const isEnabled = enabledField.value === '1';

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        const currentValue = field.value;
        enabledField.set(checked ? '1' : '0');

        if (checked) {
            if (currentValue === undefined || currentValue === null) {
                field.set('');
            }
            onEnabledChange && onEnabledChange(fieldName, currentValue || '');
        }
    };

    return (
        <div className="form-group">
            <CheckboxInput
                label={label}
                checked={isEnabled}
                onChange={handleCheckboxChange}
            />
            {isEnabled && (
                <HtmlField
                    key={fieldName}
                    field={field}
                    mrkdownField={mrkdownField}
                    showLabel={true}
                    initialValue={initialValue}
                />
            )}
        </div>
    );
};

export default CustomizableHtmlField;

